//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
export default {
    computed: {
        title () {
            return this.is_little_point ? '暂时无法评论' : ''
        },
        btn_tx () {
            return this.is_little_point ? '去赚积分' : this.copy_text ? '复制微信号' : '好的'
        },
        is_little_point () {
            return this.error_type === '积分不足'
        }
    },
    methods: {
        toggleShow () {
            this.$emit('hide')
        },
        handle () {
            if (this.copy_text) {
                WX_API.setClipboardData(this.copy_text)
            }
            if (this.is_little_point) {
                wx.navigateTo({
                    url: `/pages/packageA/consultant_task/main`
                })
            }
            this.toggleShow()
        }
    },
    props: {
        show: Boolean,
        copy_text: String,
        contents: Array,
        error_type: String
    }
}
